export default __webpack_public_path__ + "static/media/Animations_Cog4.2a6a2af7.svg";